import { useSelector } from 'react-redux';
import { PieChart, Pie, Cell } from 'recharts';

import getElectConsumptionDataStatsSelector from '/business/shared/state/selectors/application/electricityHeatSteam/getElectConsumptionDataStatsSelector';

import StyledConsumptionPie from './__styled__/StyledConsumptionPie';
import styled from 'styled-components';
import Colours from '/shared/styled/Colours';
const LegendItem = styled.li`
    display: flex;  
`;

const LegendSwatch = styled.span`
  width: 12px;
  height: 12px;
  background-color: ${({ color }) => color};
  margin-right: 8px;
  border-radius: 2px;
`;
function ConsumptionPie() {
  const { totalKwhCoveredByCertificate, totalKwhNotCoveredByCertificate, totalKwhOnsiteRenewables } = useSelector(
    getElectConsumptionDataStatsSelector,
  );

  const data = [
    {
      name: 'Covered by EACs',
      key: 'covered',
      value: totalKwhCoveredByCertificate,
      fill: Colours.greenDark3,
    },
    {
      name: 'Not covered by EACs',
      key: 'remaining',
      value: totalKwhNotCoveredByCertificate,
      fill: Colours.green,
    },
    {
      name: 'On-site renewables',
      key: 'onsite',
      value: totalKwhOnsiteRenewables,
      fill: Colours.greenDark8,
    },
  ];

  const pieTotal = data.reduce((acc, entry) => acc + (entry.value || 0), 0);

  const width = 160;
  const height = 160;
  return (
    <StyledConsumptionPie>
      <PieChart width={width} height={height}>
        <Pie
          data={data}
          // label={hasLabel ? renderCustomizedLabel : null}
          innerRadius={width / 4}
          outerRadius={width / 2}
          fill={Colours.purple}
          dataKey="value"
        >
          {data.map((entry) => (
            <Cell key={`cell-${entry.key}`} fill={entry.fill} />
          ))}
        </Pie>
      </PieChart>
      <div>
        <ul>
          {data.map((entry) => (
            <LegendItem key={`legend-${entry.key}`}>
              <LegendSwatch color={entry.fill} />

              <span>
                {entry.name} -{' '}
                {pieTotal > 0
                  ? ((entry.value / pieTotal) * 100).toLocaleString(undefined, { maximumFractionDigits: 2 })
                  : '0'}
                %
              </span>
            </LegendItem>
          ))}
        </ul>
      </div>
    </StyledConsumptionPie>
  );
}

export default ConsumptionPie;
